import { AppSidebar } from "./AppSidebar"

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col md:flex-row w-full bg-background">
      <AppSidebar />

      <main className="flex-1 p-4 md:p-6 w-full max-w-[100vw] overflow-x-hidden">
        {children}
      </main>
    </div>
  )
}